import './App.css';
import ExpressionDetector from './ExpressionDetector';

function App() {
  return (
    <div className="App">
      <ExpressionDetector />
    </div>
  );
}

export default App;
